// Wester Arizon aEntitlements
export const WESTERN_ARIZONA_URL = `/api/western_arizona`;
export const WESTERN_AZ_ENTITLMENTS_URL = `${WESTERN_ARIZONA_URL}/entitlements`;
export const WESTERN_AZ_PRIORITY_ENTITLMENTS_URL = `${WESTERN_ARIZONA_URL}/priority_entitlements`;
export const WESTERN_AZ_ENTITY_ENTITLMENTS_URL = `${WESTERN_ARIZONA_URL}/entity_entitlements`;
export const WESTERN_AZ_ENTITIES_URL = `${WESTERN_ARIZONA_URL}/entities`;